import client from "../Client/HttpClient";
import { IDepartmentsModel } from "@/interfaces/modules";
const ApiPath = "SystemDepartments";

export default {
  GetDepartments: (): Promise<IDepartmentsModel[]> => client.get(`${ApiPath}`),
  GetDepartmentsById: (data: IDepartmentsModel): Promise<IDepartmentsModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostDepartments: (data: IDepartmentsModel): Promise<IDepartmentsModel> =>
    client.post(`${ApiPath}`, data),
};
